import { render } from "./SignToJoinPartnership.vue?vue&type=template&id=3044a3d3&scoped=true&ts=true"
import script from "./SignToJoinPartnership.vue?vue&type=script&lang=ts"
export * from "./SignToJoinPartnership.vue?vue&type=script&lang=ts"

import "./SignToJoinPartnership.vue?vue&type=style&index=0&id=3044a3d3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3044a3d3"]])

export default __exports__